<template>
  <div class="lp-page">
    <SiteHeader/>

    <!-- HERO -->
    <section class="lp-hero">
      <v-container class="pt-16 pb-16">
        <v-row align="center">
          <v-col cols="12" md="6">
            <h1 class="lp-hero-title">
              {{ $t('home.lpAfiliados.heroTitleLine1') }}<br/>
              {{ $t('home.lpAfiliados.heroTitleLine2') }}
            </h1>
            <p class="lp-hero-subtitle">{{ $t('home.lpAfiliados.heroSubtitle') }}</p>
            <div class="d-flex flex-wrap align-center mt-6">
              <a :href="loginHref" class="link mr-4 mb-2" v-if="!isLogged">
                <v-btn color="#0277BD" rounded x-large depressed class="btn-migly btn-migly-primary text-none px-8">
                  <v-icon class="mr-2">mdi-google</v-icon>
                  {{ $t('home.heroCtaFree') }}
                </v-btn>
              </a>
              <v-btn v-else color="#0277BD" rounded x-large depressed class="btn-migly btn-migly-primary text-none px-8 mb-2" @click="$router.push('/painel/links/shortened')">
                {{ $t('myAccount') }}
              </v-btn>
              <a href="/#recursos" class="nav-link mb-2">{{ $t('home.lpAfiliados.heroSecondaryLink') }}</a>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="lp-hero-media">
              <v-carousel :show-arrows="false" hide-delimiter-background cycle height="auto" class="lp-carousel">
                <v-carousel-item
                  v-for="(item, i) in screenshots"
                  :key="i"
                  :eager="i === 0"
                >
                  <v-img :src="item.src" :alt="$t(item.altKey)" aspect-ratio="1.55" class="lp-carousel-img"/>
                </v-carousel-item>
              </v-carousel>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- RASTREAMENTO DE ORIGEM -->
    <section class="lp-feature">
      <v-container class="pt-16 pb-16">
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-img src="/images/lp1/painel.png" :alt="$t('home.lpAfiliados.trackingImageAlt')" class="lp-feature-img" loading="lazy"/>
          </v-col>
          <v-col cols="12" md="6">
            <h2 class="lp-feature-title">{{ $t('home.lpAfiliados.trackingTitle') }}</h2>
            <p class="lp-feature-desc">{{ $t('home.lpAfiliados.trackingDesc') }}</p>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- BIO PAGE -->
    <section class="lp-feature lp-feature-alt">
      <v-container class="pt-16 pb-16">
        <v-row align="center">
          <v-col cols="12" md="6" order="2" order-md="1">
            <h2 class="lp-feature-title">{{ $t('home.lpAfiliados.bioTitle') }}</h2>
            <p class="lp-feature-desc">{{ $t('home.lpAfiliados.bioDesc') }}</p>
          </v-col>
          <v-col cols="12" md="6" order="1" order-md="2">
            <v-img src="/images/lp1/bio.png" :alt="$t('home.lpAfiliados.bioImageAlt')" class="lp-feature-img" loading="lazy"/>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- CTA FINAL -->
    <section class="lp-final-cta">
      <v-container class="pt-16 pb-16 text-center">
        <h2 class="lp-final-cta-title">{{ $t('home.lpAfiliados.finalCtaTitle') }}</h2>
        <a :href="loginHref" class="link" v-if="!isLogged">
          <v-btn color="#0277BD" rounded x-large depressed class="btn-migly btn-migly-primary text-none px-8 mt-6">
            <v-icon class="mr-2">mdi-google</v-icon>
            {{ $t('home.heroCtaFree') }}
          </v-btn>
        </a>
        <v-btn v-else color="#0277BD" rounded x-large depressed class="btn-migly btn-migly-primary text-none px-8 mt-6" @click="$router.push('/painel/links/shortened')">
          {{ $t('myAccount') }}
        </v-btn>
      </v-container>
    </section>

    <SiteFooter/>
  </div>
</template>

<script>
import SiteHeader from "./fragments/SiteHeader.vue";
import SiteFooter from "./fragments/SiteFooter.vue";
import authSession from "../../service/auth-session";

export default {
  name: 'LPMarketingAfiliados',
  components: {
    SiteHeader,
    SiteFooter,
  },
  data: () => ({
    screenshots: [
      { src: '/images/lp1/redirect.png', altKey: 'home.lpAfiliados.redirectImageAlt' },
      { src: '/images/lp1/painel.png', altKey: 'home.lpAfiliados.trackingImageAlt' },
      { src: '/images/lp1/config.png', altKey: 'home.lpAfiliados.configImageAlt' },
      { src: '/images/lp1/opengraph.png', altKey: 'home.lpAfiliados.opengraphImageAlt' },
      { src: '/images/lp1/bio.png', altKey: 'home.lpAfiliados.bioImageAlt' },
    ],
  }),
  mounted: function() {
    authSession.checkSession()
  },
  computed: {
    isLogged: function() {
      return authSession.state.authenticated
    },
    loginHref: function() {
      return `${process.env.VUE_APP_API_V1_URL}/oauth2/authorization/google`
    },
  },
}
</script>

<style scoped>
.lp-page {
  font-family: 'Montserrat', sans-serif;
  background: #F7F5EF;
  padding-top: 72px;
}

.lp-hero {
  background: #F7F5EF;
}
.lp-hero-title {
  font-weight: 900;
  font-size: 2.6rem;
  line-height: 1.2;
  color: #101827;
  letter-spacing: -0.01em;
}
.lp-hero-subtitle {
  color: #5B6472;
  font-size: 1.05rem;
  max-width: 480px;
  margin-top: 1rem;
}
.lp-hero-media {
  border-radius: 1.25rem;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(16,24,39,0.1);
}
.lp-carousel-img {
  border-radius: 1.25rem;
}

.nav-link {
  display: inline-block;
  position: relative;
  color: #101827;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: color 0.2s ease;
}
.nav-link:hover {
  color: #0277BD;
}

/*
 * Botões padronizados. O Vuetify tem uma regra global `[class*="text-"]`
 * que colide com a classe utilitária `text-none` (usada para remover o
 * uppercase padrão) e sobrescreve a cor do texto para um cinza-azulado
 * quase invisível em botões com fundo escuro. Forçamos branco explicitamente
 * com ::v-deep para não depender dessa cascata frágil.
 */
.btn-migly-primary ::v-deep .v-btn__content {
  color: #FFFFFF !important;
}
.btn-migly {
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
.btn-migly-primary:hover {
  background-color: #01579B !important;
  border-color: #01579B !important;
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(2,119,189,0.35);
}

.lp-feature {
  background: #FFFFFF;
}
.lp-feature-alt {
  background: #F7F5EF;
}
.lp-feature-img {
  border-radius: 1.25rem;
  box-shadow: 0 20px 40px rgba(16,24,39,0.08);
}
.lp-feature-title {
  font-weight: 800;
  font-size: 1.9rem;
  color: #101827;
  margin-bottom: 1rem;
  line-height: 1.3;
}
.lp-feature-desc {
  color: #5B6472;
  font-size: 1rem;
  line-height: 1.7;
  max-width: 480px;
}

.lp-final-cta {
  background: #101827;
}
.lp-final-cta-title {
  font-weight: 800;
  font-size: 2rem;
  color: #FFFFFF;
  max-width: 620px;
  margin: 0 auto;
}

@media (max-width: 960px) {
  .lp-hero-title {
    font-size: 2rem;
  }
  .lp-feature-desc {
    max-width: none;
  }
}
</style>
